/**
 * The host dashboard's tab bar — host event edit handoff §"Tab bar". Sticky under the top
 * bar (`--hev-top` is the bar's measured height), #F5F5F5 with the 2px rule, 38px pills that
 * scroll sideways; the active pill is black with the RING as its border; counts are magenta
 * 18px bubbles. `tabs`: [{ key, label, count }].
 */
import React from 'react';

export default function HostTabBar({ tabs = [], active, onChange, ariaLabel = 'Host dashboard', testId = 'host-tabs' }) {
  return (
    <div className="hev-tabs" data-testid={testId}>
      <div className="hev-tabs-inner" role="tablist" aria-label={ariaLabel}>
        {tabs.map((t) => {
          const on = t.key === active;
          const n = t.count !== undefined && t.count !== null && t.count !== '' && t.count !== 0 ? t.count : null;
          return (
            <button key={t.key} type="button" role="tab" aria-selected={on} data-tab={t.key} className="hev-tab" data-on={on ? '' : undefined} onClick={() => onChange?.(t.key)}>
              {t.label}
              {n !== null && <span className="hev-tab-n">{n}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
